module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_power_tools_96a206b28b3936589a4f25a518ef3fe2.png";